export default {
      id: "icon-drapeau-sexe-usage",
      viewBox: "0 0 200.9 105.7",
      url: __webpack_public_path__ + "icons.svg#icon-drapeau-sexe",
      toString: function () {
        return this.url;
      }
    }